import { type RecType } from '@/defs/rec'
import { formatSigFig } from '@/utils/formatUtil'

import { StatCommonBox } from '../../StatCommon/StatCommonBox/StatCommonBox'
import { StatRecInclusionTooltip } from '../StatRecInclusionTooltip/StatRecInclusionTooltip'

import styles from './StatRecDeckFraction.module.scss'

type Props = {
  rec: RecType
}

export const StatRecDeckFraction = ({ rec }: Props) => {
  const { numDecks, potentialDecks } = rec

  const isValid = numDecks && potentialDecks

  return (
    <StatCommonBox label='Decks' popover={isValid ? <StatRecInclusionTooltip rec={rec} /> : undefined}>
      {isValid && (
        <div className={styles.container}>
          <data className={styles.figure} value={numDecks}>
            {formatSigFig(numDecks)}
          </data>
          <hr className={styles.divider} />
          <data className={styles.figure} value={potentialDecks}>
            {formatSigFig(potentialDecks)}
          </data>
        </div>
      )}
    </StatCommonBox>
  )
}
